 


import type { RouteObject } from 'react-router';
import { lazyRoute, lazyRouteWithProps } from '../utils/lazyRoute';

const inventoryRoutes: RouteObject[] = [
  {
    path: 'INV/InventorySettings/*',
    children: [
      { path: 'Inventory', lazy: lazyRoute(() => import('../../pages/INV/INVSettings/Inventory/Inventory/Index')) },
      { path: 'Inventory/:Id/SubInventory', lazy: lazyRoute(() => import('../../pages/INV/INVSettings/Inventory/SubInventory/SubInventory')) },
      {
        path: 'Inventory/:inventoryId/AssignmentItems',
        lazy: lazyRoute(() => import('../../pages/INV/INVSettings/Inventory/AssignmentItemsPaged/AssignmentItems'))
      },

      { path: 'Categories', lazy: lazyRoute(() => import('../../pages/INV/INVSettings/Categories/Index')) },

      { path: 'MasterItems', lazy: lazyRoute(() => import('../../pages/INV/INVSettings/MasterItems/Index')) },
      {
        path: 'MasterItems/:ItemId/ItemsDetails',
        lazy: lazyRoute(() => import('../../pages/INV/INVSettings/MasterItems/MasterItemsDetails/MasterItemsDetails'))
      },

      { path: 'Suppliers', lazy: lazyRoute(() => import('../../pages/INV/INVSettings/Suppliers/Index')) },
      { path: 'Suppliers/:Id/Edit', lazy: lazyRoute(() => import('../../pages/INV/INVSettings/Suppliers/EditSuppliers')) },

      { path: 'UnitsOfMeasure', lazy: lazyRoute(() => import('../../pages/INV/INVSettings/UnitsOfMeasure/Index')) },

      { path: 'TransactionTypes', lazy: lazyRoute(() => import('../../pages/INV/INVSettings/TransactionTypes/Index')) },
      {
        path: 'TransactionTypes/:transactionType/TypeReasons',
        lazy: lazyRoute(() => import('../../pages/INV/INVSettings/TransactionTypes/TypeReasons/TypeReasons'))
      },

      { path: 'Attributes', lazy: lazyRoute(() => import('../../pages/INV/INVSettings/Attributes/Index')) },

      { path: 'Brand', lazy: lazyRoute(() => import('../../pages/INV/INVSettings/Brand/Index')) }
    ]
  },

  {
    path: 'INV/Transactions/*',
    children: [
      { path: 'All', lazy: lazyRoute(() => import('../../pages/INV/Transactions/AllTransactions/Index')) },

      { path: 'InvIssue', lazy: lazyRoute(() => import('../../pages/INV/Transactions/InvIssue/Index')) },
      { path: 'InvIssue/AddInvIssue', lazy: lazyRoute(() => import('../../pages/INV/Transactions/InvIssue/Add')) },
      { path: 'InvIssue/:Id/UpdateInvIssue', lazy: lazyRoute(() => import('../../pages/INV/Transactions/InvIssue/Update')) },

      { path: 'InvReceive', lazy: lazyRoute(() => import('../../pages/INV/Transactions/InvReceive/Index')) },
      { path: 'InvReceive/AddInvReceive', lazy: lazyRoute(() => import('../../pages/INV/Transactions/InvReceive/Add')) },
      { path: 'InvReceive/:id/UpdateInvReceive', lazy: lazyRoute(() => import('../../pages/INV/Transactions/InvReceive/Update')) },

      { path: 'InvMove', lazy: lazyRoute(() => import('../../pages/INV/Transactions/InvMove/Index')) },
      { path: 'InvMove/AddInvMove', lazy: lazyRoute(() => import('../../pages/INV/Transactions/InvMove/Add')) },
      { path: 'InvMove/:id/UpdateInvMove', lazy: lazyRoute(() => import('../../pages/INV/Transactions/InvMove/Update')) },

      { path: 'UpdateCost', lazy: lazyRoute(() => import('../../pages/INV/Transactions/UpdateCost/Index')) },
      { path: 'UpdateCost/AddUpdateCost', lazy: lazyRoute(() => import('../../pages/INV/Transactions/UpdateCost/Add')) },
      { path: 'UpdateCost/:id/UpdateUpdateCost', lazy: lazyRoute(() => import('../../pages/INV/Transactions/UpdateCost/Update')) },

      { path: 'Allocate', lazy: lazyRoute(() => import('../../pages/INV/Transactions/Allocate/Index')) },
      { path: 'Allocate/AddInvAllocate', lazy: lazyRoute(() => import('../../pages/INV/Transactions/Allocate/Add')) },
      { path: 'Allocate/:id/UpdateInvAllocate', lazy: lazyRoute(() => import('../../pages/INV/Transactions/Allocate/Update')) },

      { path: 'CreateAccountInventory', lazy: lazyRoute(() => import('../../pages/INV/CreateAccount/ListTransactions')) },

      {
        path: 'AccountingPeriod',
        lazy: lazyRouteWithProps(
          () => import('../../pages/Finance/Settings/AccountingPeriod/Index'),
          () => ({ customProp: 'Inv' as const })
        )
      }
    ]
  },

  { path: 'INV/Reports', lazy: lazyRoute(() => import('../../pages/INV/InvReports/InvReports')) },
  { path: 'INV/HomePage', lazy: lazyRoute(() => import('../../pages/INV/Home/InvDashboard')) },

  {
    path: 'INV/InventoryCount/*',
    children: [
      { path: '*', lazy: lazyRoute(() => import('../../pages/INV/InventoryCount/InventoryCount/Index')) },

      // كان عندك AddInventoryCount قديم معلّق — اعتمدت الحالي InventoryCountForm
      { path: 'AddInventoryCount', lazy: lazyRoute(() => import('@pages/INV/InventoryCount/InventoryCount/InventoryCountForm')) },

      // Edit يستخدم نفس الفورم
      { path: ':id/EditInventoryCount', lazy: lazyRoute(() => import('@pages/INV/InventoryCount/InventoryCount/InventoryCountForm')) },

      {
        path: ':invCountId/InventoryCountEntries',
        lazy: lazyRoute(() => import('../../pages/INV/InventoryCount/Test/InventoryEntries'))
      }
    ]
  }
];

export default inventoryRoutes;
